export default __webpack_public_path__ + "media/images/avatars/avatar10-7e0cc79eb9cd6d9031ea15eb19ef3372.png";